module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@beisen/chaos-ui","commonjs2":"@beisen/chaos-ui","commonjs":"@beisen/chaos-ui","amd":"@beisen/chaos-ui"}
// module id = 10
// module chunks = 1